<template>
  <div>
    <!-- 加载中 -->
  </div>
</template>

<script>
export default {
  created() {
    const query = this.$route.query;
    console.log('query', query);
    if (query.path) {
      localStorage.setItem('_gateway_path', query.path)
    }
    if (query.data) {
      localStorage.setItem('_gateway_data', query.data)
    }
    // 跳转到登录，尝试获取 homeUrl
    let url = localStorage.getItem("homeUrl");
    if (!url) {
      url = location.origin;
    }
    location.replace(url);
  }
}
</script>

<style>

</style>